export const TEXTS = {
  QUANTITY: 'Qty',
  DELIVERS_BY: 'Delivers by',
  PERCENTTAGE_OFF: '% off',
  VIEW_SIMILAR: 'View Similar',
  REMOVE: 'Remove',
  MOVE_TO_WISHLIST: 'Move to Wishlist',
  SIZE: 'Size:',
  RETURN: 'Return',
  SIZE_EXCHANGE: 'Size Exchange',
  NO_RETURN_EXCHANGE: 'No Return/Exchange',
  DAYS: 'Day',
  OOS_TEXT: 'Product is out of stock',
};

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const REMOVE_ACTION_NUDGE_THUMBNAIL_SIZE = 64;

export const REMOVE_PRODUCT_CART_BUTTON_SIZE = '24px';
